"use client";

import { OspModalType } from "@ospweb/sdk-ui/src/modal/types";
import { ospThemes } from "@ospweb/sdk-ui";
import { EdgenModalCreateAble } from "../../EdgenModal";
import { LowCreditModal, LowCreditModalProps } from "./LowCreditModal";

type LowCreditModalCreateAbleProps = Omit<LowCreditModalProps, "onClose"> & {
  modalProps?: OspModalType;
};

/**
 * 函数式调用 LowCreditModal
 * @example
 * await LowCreditModalCreateAble({ credits: 10 });
 */
export const LowCreditModalCreateAble = async (
  props?: LowCreditModalCreateAbleProps,
): Promise<void> => {
  const { modalProps, ...otherProps } = props || {};
  return new Promise((resolve) => {
    const modalInstance = EdgenModalCreateAble.call({
      centered: true,
      children: (
        <LowCreditModal
          {...otherProps}
          credits={props?.credits}
          className={props?.className}
          onClose={() => {
            EdgenModalCreateAble.end(modalInstance, false);
            resolve();
          }}
        />
      ),
      containerClassName: "max-w-full w-full w-[320px] md:w-[400px] md:px-0",
      contentStyle: {
        borderRadius: 16,
        backgroundColor: ospThemes.colors.background_solid_secondary,
        width: "100%",
        padding: 0,
        overflow: "hidden",
      },
      closeStyle: {
        backgroundColor: ospThemes.colors.background_solid_secondary,
      },
      destroyOnClose: true,
      onCancel: () => {
        EdgenModalCreateAble.end(modalInstance, false);
        resolve();
      },
      ...modalProps,
    });
  });
};
